import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appTags',
  getURL: 'appId/manualtags',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  sessionParams: ['appId'],
  emptyMessage: "You don’t have any tags yet. Go to the Tag Manager to create your first one.",
  emptyButtonUrl:"/tagmanager/new",
  emptyButton:"+ Create New Tag",
  createButton: "Create New Tag",
  createButtonUrl: "/tagmanager/new",
  fields: [
    {
      attributeName: 'typeTagAssignment',
      label: 'Assignment',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:false,
      canEdit: false,
      canCreate: false,
      helpText: 'Asignment of the tag.',
    },
    {
      attributeName: 'typeTagName',
      label: 'Category',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Category of the tag.',
    },
    {
      attributeName: 'appTagName',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the tag.',
    },
    {
      attributeName: 'iconId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Icon',
      helpText: 'Icon of the tag.',
      placeholder: 'Icon...',
      fileType: ['image/*'],
      canUpdate:false,
      hasSelect:false,
      enabledWhen:{"field":"locked","values":[0]}
    },
  ],
};
